import React from 'react'
import { Link } from 'react-router-dom'
const Page404 = props => (
  <>
    <h1>{'La pagina che stavi cercando non esiste'}</h1>
    <Link to={'/'}>{'Torna alla home'}</Link>
  </>
)
export default Page404
